import './index.css';
import { Link, useNavigate } from 'react-router-dom';
import React, { useState } from "react";
import { useAuth } from '../../context/AuthContext';

const Header = () => {
  const { user, openLoginModal, openRegisterModal, logout } = useAuth();
  const navigate = useNavigate();
  const [searchKeyword, setSearchKeyword] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    const trimmed = searchKeyword.trim();
    if (trimmed) {
      navigate(`/tool-search/${encodeURIComponent(searchKeyword)}`);
    } else {
      navigate('/home');
    }
  };

  return (
    <div className="page-header">
      <div className="header-left">
        <a href="/">
          <img src="../logo.png" width={128} height={128} alt="logo" className="logo-img" />
          <h2>生图工具网</h2>
        </a>
      </div>
      
      {/* 
      

      <div className="header-right">
        {user ? (
          <>
            <Link to="/user-center" className="user-center-link">
              {user.avatar ? (
                <img src={user.avatar} alt="头像" className="header-avatar" />
              ) : (
                <span className="header-avatar-text">
                  {user.nickname ? user.nickname.slice(0, 1).toUpperCase() : 'U'}
                </span>
              )}
              <span className="user-name">欢迎, {user.nickname || user.name}</span>
              <span className="header-balance">余额 ¥{Number(user.balance || 0).toFixed(2)}</span>
            </Link>
            <button onClick={logout} className="auth-btn">退出</button>
          </>
        ) : (
          <button onClick={() => openLoginModal()} className="auth-btn">登录</button>
        )}
        {!user && (
          <button onClick={openRegisterModal} className="auth-btn register-btn">注册</button>
        )}
        <form className="search-form" onSubmit={handleSearch}>
          <input
            type="text"
            placeholder="搜索工具..."
            value={searchKeyword}
            onChange={(e) => setSearchKeyword(e.target.value)}
            className="search-input"
          />
          <button type="submit" className="search-btn">搜索</button>
        </form>
      </div>

      */}


    </div>
  );
};

export default Header;